module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doctorVote"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.title
    }
  })]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('ul', {
    staticClass: "itemList"
  }, [_c('li', [_c('span', [_vm._v(_vm._s(_vm.votedPersonCounts))]), _vm._v(" 人已投 "), _c('span', [_vm._v(_vm._s(_vm.votedCounts))]), _vm._v(" 票")])]), _vm._v(" "), (this.votedoctorData.length != 0) ? _c('p', {
    staticClass: "itemtitle"
  }, [_vm._v("您投票的医生")]) : _vm._e(), _vm._v(" "), _c('grid', {
    staticClass: "doctorList votedoctorList",
    attrs: {
      "cols": 3,
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, _vm._l((_vm.votedoctorData), function(item, index) {
    return _c('grid-item', {
      key: index
    }, [_c('div', {
      staticClass: "grid-center"
    }, [_c('img', {
      attrs: {
        "src": 'http://front.wh.jinxin-fertility.com/doctorImg/' + item.imagename
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.remark) + "  " + _vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "academic"
    }, [_vm._v(_vm._s(item.descirption))]), _vm._v(" "), _c('p', {
      staticClass: "vote"
    }, [_c('span', [_vm._v(_vm._s(item.votetimes))]), _vm._v(" 票")])])])
  })), _vm._v(" "), _c('p', {
    staticClass: "itemtitle"
  }, [_vm._v("参赛医生")]), _vm._v(" "), _c('grid', {
    staticClass: "doctorList",
    attrs: {
      "cols": 3,
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, _vm._l((_vm.doctorData), function(item, index) {
    return _c('grid-item', {
      key: index
    }, [_c('div', {
      staticClass: "grid-center"
    }, [_c('div', {
      staticClass: "flge"
    }, [_vm._v(_vm._s(item.no))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": 'http://front.wh.jinxin-fertility.com/doctorImg/' + item.imagename
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('p', {
      staticClass: "academic"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.descirption))]), _vm._v(" "), _c('p', {
      staticClass: "vote"
    }, [_c('span', [_vm._v(_vm._s(item.votetimes))]), _vm._v(" 票")]), _vm._v(" "), (_vm.votebtn) ? _c('x-button', {
      attrs: {
        "mini": "",
        "gradients": ['#0061ae', '#0061ae']
      },
      nativeOn: {
        "click": function($event) {
          _vm.voteClick(item.id, item.name)
        }
      }
    }, [_vm._v("投TA一票")]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": "提示"
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("确定投 " + _vm._s(_vm.confirmTxt) + "医生 一票？")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "show": _vm.loadingshow,
      "text": "加载中"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "decioner"
  }, [_vm._v("\n      弘扬崇高精神，聚力健康中国，2019西囡妇科医院医师节暨第二届优秀医师评选活动开始啦："), _c('br'), _vm._v("\n在西囡有这么一群人，他们身穿朴素的白衣，肩扛神圣的责任，他们面对的是无数的挑战，但他们用专注和专业为我们带来生命的希望；每一个西囡父母的微笑都离不开他们的付出，每一个西囡宝贝的诞生都离不开他们的努力；虽然他们有时候很严厉，但他们是我们西囡最可爱的医生！"), _c('br'), _vm._v("\n8月19日，是属于他们的节日，值此第二届“中国医师节”来临之际，用让我们一起为从事着这项神圣而伟大事业的医师点赞，让我们用实际行动，为我们心中的“优秀医师”投上宝贵的一票吧！"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "color": "rgb(232,14,65)",
      "text-align": "center"
    }
  }, [_vm._v("（每人可投三票）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3736654a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/voteProject/doctorVote1.vue
// module id = +8hC
// module chunks = 7